import React from 'react';
import { TrendingUp } from 'lucide-react';
import { formatPublishNp } from '../../utils/timeAgo';

function TrendingNews({ items, onOpen }) {
  if (!items || items.length === 0) return null;

  return (
    <div className="bg-white border border-line rounded-[14px] p-5 shadow-sm min-w-0">
      <h4 className="flex items-center gap-2 text-[15px] font-bold mb-4">
        <TrendingUp size={16} className="text-crimson" /> ट्रेन्डिङ
      </h4>
      <ol className="flex flex-col">
        {items.map((item, i) => (
          <li
            key={item.id}
            className="flex gap-3 py-3 border-b border-line last:border-none last:pb-0 cursor-pointer"
            onClick={() => onOpen(item)}
            role="button"
            tabIndex={0}
          >
            <span className="font-display text-2xl font-bold text-paper-tint [-webkit-text-stroke:1.3px_#2457A8] leading-none flex-shrink-0">
              {String(i + 1).padStart(2, '0')}
            </span>
            <div className="min-w-0">
              <p className="text-[14.5px] font-semibold leading-snug mb-1 transition-colors hover:text-blue">{item.title}</p>
              <span className="text-[11.5px] text-muted">{formatPublishNp(item.created_at || item.date)}</span>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default TrendingNews;